import axios from 'axios'
import { make } from 'vuex-pathify'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import store from '../index'

const state = {
  jobs: [],
  count: 0,
  loading: false,
  submitting: false,
}

const mutations = make.mutations(state)

const actions = {
  async createJob ({ state, dispatch }, payload) {
    state.submitting = true

    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/report-jobs?${getQueryFromFilter({})}`,
        payload,
      )

      showSuccess('Relatório enviado para processamento em background.')
      dispatch('get', { module: payload.module }).catch(showError)
      return data
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.submitting = false
    }
  },

  async get ({ state }, filter = {}) {
    state.loading = true

    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL}/report-jobs?${getQueryFromFilter({
          itemsPerPage: 30,
          ...filter,
        })}`,
      )

      state.jobs = data.data || []
      state.count = data.count || 0
      return state.jobs
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.loading = false
    }
  },

  async download (_, job) {
    try {
      const signedUrl = await store.dispatch('fileStore/get', { path: job.filePath })
      window.open(signedUrl, '_blank')
    } catch (error) {
      showError(error)
    }
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
